import { Breakpoint, Color, FontWeight, Icon, IconName, Typography, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { KnowledgeBaseViewMode } from '../../../../enums';
import { useAuth } from '../../../../hooks';
import { UseAuth } from '../../../../interfaces';

import { ViewOptionButton, ViewOptionsButtonsWrapper, ViewOptionsWrapper } from './viewOptions.styled';

export const ViewOptions: React.FC = (): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const isTablet: boolean = useMediaQuery({ query: Breakpoint.Tablet });
  const { appSettings, changeKnowledgeBaseViewMode }: UseAuth = useAuth();
  const viewMode: KnowledgeBaseViewMode = appSettings?.knowledgeBaseViewMode ?? KnowledgeBaseViewMode.Grid;

  return (
    <ViewOptionsWrapper>
      {!!isTablet && (
        <Typography fontWeight={FontWeight.Bold} variant={TypographyVariant.Subheader}>
          {t('competence.app.knowledgeBaseV2.viewOptions')}
        </Typography>
      )}
      <ViewOptionsButtonsWrapper>
        <ViewOptionButton onClick={(): void => changeKnowledgeBaseViewMode(KnowledgeBaseViewMode.List)}>
          <Icon
            color={viewMode === KnowledgeBaseViewMode.List ? Color.Brand300 : Color.Black100}
            name={IconName.MenuHamburger}
            size={20}
          />
        </ViewOptionButton>
        <ViewOptionButton onClick={(): void => changeKnowledgeBaseViewMode(KnowledgeBaseViewMode.Grid)}>
          <Icon
            color={viewMode === KnowledgeBaseViewMode.Grid ? Color.Brand300 : Color.Black100}
            name={IconName.MenuVsOutline}
            size={20}
          />
        </ViewOptionButton>
      </ViewOptionsButtonsWrapper>
    </ViewOptionsWrapper>
  );
};
